import { useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { mdiAlert } from '@mdi/js'
import Icon from '@mdi/react'
import theme from 'theme_'
import ROUTES from 'app/routes'
import {
  SubscriptionStatusButton,
  SubscriptionStatusInformationContainer,
  SubscriptionStatusInformationText,
} from '../styles'

interface SubsriptionStatusInformationProps {
  rootDomainId: string
  homeId: string
  jobId: string
}

function SubsriptionStatusInformation({
  rootDomainId,
  homeId,
  jobId,
}: SubsriptionStatusInformationProps) {
  const history = useHistory()

  const handleClickToClaimDevice = useCallback(() => {
    const path = generatePath(ROUTES.networkAi.dashboard.rootNoJob, {
      rootDomainId,
      jobId,
      homeId,
    })
    history.push(path)
  }, [history, homeId, jobId, rootDomainId])

  return (
    <SubscriptionStatusInformationContainer isSuccess={false}>
      <Icon path={mdiAlert} size={0.8} color={theme.colors.error} />
      <SubscriptionStatusInformationText>
        Subscription expired. Please susbcribe.
      </SubscriptionStatusInformationText>
      <SubscriptionStatusButton
        variant="primary"
        onClick={handleClickToClaimDevice}
      >
        Subscribe
      </SubscriptionStatusButton>
    </SubscriptionStatusInformationContainer>
  )
}

export default SubsriptionStatusInformation
